import React, { useState, useEffect } from "react";
import { Container, Row, Col, Button, Image, Form } from "react-bootstrap";
import Slider from "react-slick";
import axios from "axios";
import { useParams } from "react-router-dom";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import PaymentModal from "../../components/PaymentModal/PaymentModal";
import { normalizeOximoProductForPayment } from "../../utils/productPaymentAdapters";

const API_BASE_URL = process.env.REACT_APP_API_URL;

const OximoProductDetail = () => {
  const [product, setProduct] = useState(null);
  const [quantity, setQuantity] = useState(1);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const { symbol } = useParams(); 

  useEffect(() => {
    const fetchProductDetails = async () => {
      try { 
        const response = await axios.get(`${API_BASE_URL}api/oximo/${symbol}/?timestamp=${new Date().getTime()}`);
        setProduct(response.data);
      } catch (error) {
        console.error("Error fetching product details", error);
      }
    };

    fetchProductDetails();
  }, [symbol]); 

  if (!product) return <div>Loading...</div>;

  return (
    <div>
      <Navbar />
      <Container className="my-5">
        <Row>
          <Col md={6}>
            <Slider {...{
              dots: true,
              infinite: true,
              speed: 500,
              slidesToShow: 1,
              slidesToScroll: 1,
            }}>
              {[...Array(12)].map((_, i) => {
                const foto = product[`foto_${i + 1}`];
                return foto ? (
                  <div key={i}>
                    <Image src={foto} alt={`foto-${i + 1}`} fluid />
                  </div>
                ) : null;
              })}
            </Slider>
          </Col>

          <Col md={6}>
            <h2>{product.short_name_en}</h2>
            <p>{product.long_description_en}</p>
            {product.price ? (
              <p><strong>Price:</strong> ₦{product.price}</p>
            ) : (
              <p><strong>Price:</strong> Contact for price</p>
            )}

            <Form.Group className="mb-3" style={{ maxWidth: 180 }}>
              <Form.Label>Quantity</Form.Label>
              <Form.Control
                type="number"
                min={1}
                value={quantity}
                onChange={(e) => setQuantity(Math.max(1, Number(e.target.value) || 1))}
              />
            </Form.Group>

            <Button variant="primary" onClick={() => setShowPaymentModal(true)}>
              Buy Now
            </Button>
          </Col>
        </Row>
      </Container>
      <PaymentModal
        show={showPaymentModal}
        onHide={() => setShowPaymentModal(false)}
        product={normalizeOximoProductForPayment(product, quantity)}
      />
      <Footer />
    </div>
  );
};

export default OximoProductDetail;
